import { render, staticRenderFns } from "./indexServicer.vue?vue&type=template&id=7a98e27c&"
import script from "./indexServicer.vue?vue&type=script&lang=ts&"
export * from "./indexServicer.vue?vue&type=script&lang=ts&"
import style0 from "./indexServicer.vue?vue&type=style&index=0&id=7a98e27c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports